import LegislativnyMaterialUpdatePage from './LegislativnyMaterialUpdatePage';

export default LegislativnyMaterialUpdatePage;
